

/// <reference path="AccountingJournalLineFormulaTemplate.ts" />

// Generated class AccountingJournalGroupConditionTemplate_ManagedObject

class AccountingJournalGroupConditionTemplate_ManagedObject extends AccountingJournalLineFormulaTemplate
{

    // Property: operation
    set operation(value:number) {
        this.setValueForKey(value, 'operation');
    }
    get operation():number {
        return this.valueForKey('operation');
    }
    set operationPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'operation');
    }
    get operationPrimitiveValue():number {
        return this.primitiveValueForKey('operation');
    }
}
